import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { UtilService } from 'src/app/services/util.service';
import { Order, OrderGroup } from 'src/app/models/order.model';
import { UserService } from 'src/app/services/user.service';
import { Table } from 'src/app/models/table.model';

import { STORAGE_MY_BASKET } from 'src/environments/environment';
import { WifiService } from 'src/app/services/wifi.service';
import { OrderService } from 'src/app/services/order.service';
import { ImageService } from 'src/app/services/image.service';
import { Bonuskarte } from 'src/app/models/bonuskarte.model';
import { BonuskarteService } from 'src/app/services/bonuskarte.service';
import { Router } from '@angular/router';
import { PushService } from 'src/app/services/push.service';
import { BasketService } from 'src/app/services/basket.service';
import { IonSelect } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { ANALYTICS_EV_SAVE_BASKET, ANALYTICS_EV_LOAD_BASKET } from 'src/environments/constant';

@Component({
  selector: 'app-basket',
  templateUrl: './basket.page.html',
  styleUrls: ['./basket.page.scss'],
})
export class BasketPage implements OnInit {

  @ViewChild(IonSelect, { static: false }) elIonSelect: any;

  constructor(private router: Router, public imageService: ImageService, public db: DBService, public util: UtilService, private orderService: OrderService,
    public userService: UserService, private wifiService: WifiService, private ngZone: NgZone, private bonuscardService: BonuskarteService,
    private pushService: PushService, private basketService: BasketService, private modalController: ModalController) { }

  ionViewWillLeave() {
    this.util.popover.dismiss();
    this.modalController.dismiss();

  }

  ngOnInit() {
    //this.util.enableBonuskarten = false
    //this.events.unsubscribe('networkdetected')  //TODO: Events doesnt exist anymore, was this required???
    this.orderService.initRouter(this.router)

    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    //if restaurant doesnt support "eat here", select other default settings ...
    if (this.db.currentRestaurant.orderMode["eat-here"] != true) {
      if (this.db.currentRestaurant.orderMode["delivery"] == true) this.db.basket.mode = "delivery"
      else this.db.basket.mode = "take-away"
    }

    this.db.setPage('basket')

    this.db.sendLog('* ngOnInit basketpage')

    if (this.util.demo) {
      this.userService.currentTable = new Table("Demo")
      this.userService.currentTable.qrCode = "1"
    }

    setTimeout(() => {

      if (this.util.enableBonuskarten) {
        this.util.enableBonuskarten = false
        this.enableBonuskarte();
      } else {
        this.refreshBasketWithBonuscardInfo();
      }
      //console.log(this.db.basket.order)
    }, 200);

    //Netzwerke werden nicht mehr geloescht, weil diese immer 3 min bestehen bleiben
    //this.wifiService.networks = []

    try {
      this.wifiService.enableWifi(false)
    } catch (e) {
      console.error("Could not enable WiFi")
    }

    //Deaktiviert, weil es zu oft abgefragt wurde und Android dann eine Sperre rein gemacht hat
    //this.wifiService.initStartWifiScreening();
  }

  enableBonuskarte() {

    setTimeout(() => {
      this.refreshBasketWithBonuscardInfo(); //erst bei bonus freischaltung soll aufteilung passieren

      for (let order of this.db.basket.order) {
        if (order.bonuscardPrice !== -1 && (order.amount > 1 || !order.amount)) {
          if (order.amount > 1) { //Bonsuitem wird aufgesplittet in 1 mit Bonus und der rest in ein neues
            let newBonusOrder: Order = Object.assign(new Order('-1'), order)
            newBonusOrder.amount = order.amount - 1
            newBonusOrder.bonuscardPrice = -1
            this.db.basket.order.push(newBonusOrder)
          }
          order.amount = 1
        }
      }
      this.util.enableBonuskarten = true;

      this.refreshBasketWithBonuscardInfo(true);
    }, 200);
  }

  disableBonuskarte() {
    this.util.enableBonuskarten = false;
  }

  hasBonuskartItems(): boolean {
    for (let order of this.db.basket.order) {
      if (order.bonuscardPrice !== -1) {
        return true
      }
    }

    return false
    //*ngIf="order.bonuscardPrice !== -1 && !util.enableBonuskarten"
  }

  ngAfterViewInit() {

  }

  back(pageComponent: string = 'home') {
    this.db.setPage(pageComponent)
    this.ngZone.run(() => this.router.navigate(['/customer-home'])) //TODO: frueher stand hier back anstatt root
  }

  saveBasket() {
    if(1 > 2){ //deactivated
      this.util.presentToast("Ooops, leider ist diese Funktionalität aktuell deaktiviert - aber wir arbeiten für dich, sodass du auch bald wieder dein Warenkorb speichern kannst.", 5000, 'toast-warning')
      return
    }

    if (this.db.basket && this.db.basket.order.length > 0) {
      localStorage.setItem(STORAGE_MY_BASKET + "/" + this.db.currentRestaurantKey, JSON.stringify(this.db.basket))
      this.db.addAnalytics(ANALYTICS_EV_SAVE_BASKET)  
      this.util.presentToast("Dein Warenkorb wurde für das Lokal gespeichert", 3000, 'toast-success')
    } else {
      this.util.presentToast("Ein leerer Warenkorb kann nicht gespeichert werden", 3000, 'toast-warning')
    }
  }

  loadBasket() {
    if(1 > 2){ //deactivated
      this.util.presentToast("Ooops, leider ist diese Funktionalität aktuell deaktiviert - aber wir arbeiten für dich, sodass du auch bald wieder dein Warenkorb laden kannst.", 5000, 'toast-warning')
      return
    }

    let basketFoundAndLoaded = this.basketService.loadBasket()
    if (basketFoundAndLoaded) {
      setTimeout(() => {
        this.refreshBasketWithBonuscardInfo();
        this.db.addAnalytics(ANALYTICS_EV_LOAD_BASKET)  
      }, 200);
      this.util.presentToast("Dein Warenkorb wurde geladen", 3000, 'toast-success')
    } else {
      this.util.presentToast("Es sind keine Warenkörbe für dieses Lokal vorhanden", 3000, 'toast-warning')
    }
  }

  changeTable() {
    this.orderService.selectTableViaQRCode(undefined);
  }

  removeFromBasket(order: Order) {
    this.db.removeFromBasket(order)
    setTimeout(() => {
      this.refreshBasketWithBonuscardInfo();
    }, 200);
  }

  /*
  removeAmount(order: Order) {
    order.amount = null
  }*/

  amountChanged(order: Order) {
    let elements: any = document.getElementsByTagName("ion-input")
    if (elements && elements.length > 0) {
      for (let element of elements) {
        setTimeout(() => {
          try {
            if (element.value.split(".").length > 0) element.value = element.value.split(".")[0]
            if (element.value > 99) element.value = 99
            if (element.value < 0) element.value = 0
          } catch (error) {
            console.debug("element value cant be splitted", element.value)
          }
        }, 200)
      }
    }
    setTimeout(() => {
      this.refreshBasketWithBonuscardInfo();
    }, 400);
  }

  clickedOnBasketFooter(res: string) {
    let _this = this;
    if (res) {
      if (res === "save") {
        this.saveBasket();
      } else if (res === "load") {
        this.loadBasket();
      } else if (res === "change-table") {
        this.changeTable();
      } else {
        this.orderService.requestCaptcha()
        this.order()
      }
    }
  }

  order() {

    if (!this.db.supportsOrders()) {
      this.util.presentToast('Das Lokal unterstützt keine Online-Bestellungen. Bestelle bitte vor Ort.', 3000, 'toast-warning');
      return
    }
    
    if (!this.db.isBasketFilled()) {
      this.util.presentToast('Warenkorb ist leer', 3000, 'toast-warning');
      return
    }

    if (!this.util.enableBonuskarten) {
      for (let order of this.db.basket.order) {
        order.bonuscardPrice = -1
      }
    } else {
      for (let order of this.db.basket.order) {
        if (order.bonuscardPrice !== -1) {
          order.amount = 1  //Nochmal sicherstellen, dass jedes Bonus Item einzeln ist
        }
      }
    }

    if (!this.db.currentRestaurant.isOpen && !this.util.demo && (!this.db.currentRestaurant.preOrder || this.db.basket.mode == "eat-here")) {
      let toastText = 'Leider hat das Lokal aktuell geschlossen. Du kannst deinen Warenkorb für später speichern.'
      this.util.presentToast(toastText, 3000, 'toast-warning')
      return
    }

    this.db.basket.isNativeApp = this.util.isMobileApp2

    if (this.db.basket.mode == "eat-here") {
      if (!this.util.isMobileApp2 && !this.util.demo && !this.db.currentRestaurant.phoneValidation) {
        this.util.presentToast("Die Möglichkeit 'Hier essen' kannst du nur in der App verwenden.", 3000, 'toast-warning')
        return
      }
      this.orderService.clickOnOrderNow(this.db.basket);
    } else {
      this.db.basket.requiredTimeInMinutes = this.db.currentPreperationTime
      this.ngZone.run(() => this.router.navigate(['/eat-outside']))
    }
  }


  //******************************************************************** */
  //Ab hier Bonuskarte
  //******************************************************************** */
  refreshBasketWithBonuscardInfo(split: boolean = false) {

    let filledBonuscards: Bonuskarte[] = this.bonuscardService.getFullBonuskartenIDs(this.db.currentRestaurant);
    let usedIndexes: { [id: number]: boolean } = {};
    for (let i = 0; i < 99; i++) usedIndexes[i] = false
    this.util.debug("Filled Bonuscards", filledBonuscards)
    this.util.debug("usedIndexes (before)", usedIndexes)
    this.util.debug("this.db.basket.order", this.db.basket.order)

    /*** Bonuscards loeschen, die schon zugewiesen sind ***/
    for (let order of this.db.basket.order) {
      if (order.bonuscardPrice === -1) continue //dieser eintrag hat keine bonuskarte zugewiesen, zaehlt also nicht
      for (let i = 0; i < filledBonuscards.length; i++) {
        if (usedIndexes[i] === true) continue;
        if (this.bonuscardService.itemBelongs2Karte(order.itemKey, filledBonuscards[i])) {
          usedIndexes[i] = true
          break;
        }
      }
    }


    this.util.debug("usedIndexes (after)", usedIndexes)


    let newOrders: Order[] = []
    if (!filledBonuscards || filledBonuscards.length === 0) return

    for (let order of this.db.basket.order) {
      if (order.bonuscardPrice !== -1) continue //Wenn Order schon fuer Karte verwendet wurde, wird diese nicht mehr benoetigt
      for (let i = 0; i < filledBonuscards.length; i++) {
        if (usedIndexes[i] === true) continue
        if (this.bonuscardService.itemBelongs2Karte(order.itemKey, filledBonuscards[i])) {
          //Bonus kann nur auf ein Item angerechnet werden
          if (order.amount > 1 && (this.util.enableBonuskarten || split)) { //Aufteilen, nur wenn ich einlöse
            order.amount = order.amount - 1 //TODO: Aufsplitten geht immer nur mit einem und nicht in mehrere Karten aufsplitten
            order.bonuscardPrice = -1
            let newBonusOrder: Order = Object.assign(new Order('-1'), order)
            newBonusOrder.amount = 1
            newBonusOrder.bonuscardPrice = 0
            newOrders.push(newBonusOrder)
          } else if (!this.util.enableBonuskarten && !split) {
            order.bonuscardPrice = 0
          }

          usedIndexes[i] = true

          break; //braucht nicht nach weiteren Karten suchen
        }
      }
    }

    //Orders werden gepushed, die wegen Bonus gesplittet sind
    for (let order of newOrders) {
      this.db.basket.order.push(order)
    }

    this.basketService.setBasketMode(this.db.basket)
  }



}
